import jwtDecode from 'jwt-decode';
import Cookies from 'universal-cookie';
import axios from 'axios';

const cookies = new Cookies();

export const saveToken = (token) => {
    cookies.set('fastgestor-token', token);
}

export const getToken = () => {
    return cookies.get('fastgestor-token');
}

export const removeToken = () => {
    return cookies.remove('fastgestor-token');
}

export const removePermissoes = () => {
    // return cookies.remove('fastgestor-permissoes-');
}

export const removeStatus = async () => {
    // console.log('sair');
    await axios.get(`/usuarios/logout`)
        .then(response => {
            // console.log('sair OK');
            // console.log('sair: ', response);
        })
        .catch(error => {
            // console.log('sair ERRO');
        });
    // console.log('sair1');
    return;
}



export const savePermissoes = (grupo) => {
    const tipoUsuario = jwtDecode(getToken()).usuario.usu_tipo;
    if (tipoUsuario) {
        axios.get('/usuarios/listaPermissoes', {
            params: {
                grupo
            }
        }).then(response => {
            const { data } = response;
            const listaPermissoes = response.data;
            for (var x in listaPermissoes) {
                cookies.set('fastgestor-permissoes-' + listaPermissoes[x].pp_page, String(listaPermissoes[x].pg_consultar) + String(listaPermissoes[x].pg_novo) + String(listaPermissoes[x].pg_editar) + String(listaPermissoes[x].pg_excluir));
            };
        }).catch(error => {
            console.error(error.response);
        })
    }
}

export const getTemPermissao = (page, perm) => {
    const tipoUsuario = jwtDecode(getToken()).usuario.usu_tipo;
    // console.log('tipoUsuario: ', tipoUsuario);
    // console.log('page: ', page);
    // console.log('perm: ', perm);

    const permissoes = cookies.get('fastgestor-permissoes-' + page);
    // console.log('getTemPermissao DESC: ', permissoes);

    if (tipoUsuario) {
        if (permissoes) {
            if (String(perm) === 'cons') {
                // console.log('getTemPermissao CONS: ', String(permissoes).substring(0,1) === '1' ? true : false);
                return String(permissoes).substring(0, 1) === '1' ? true : false;
            }
            if (String(perm) === 'novo') {
                // console.log('getTemPermissao NOVO: ', String(permissoes).substring(1,2) === '1' ? true : false);
                return String(permissoes).substring(1, 2) === '1' ? true : false;
            }
            if (String(perm) === 'editar') {
                // console.log('getTemPermissao EDITAR: ', String(permissoes).substring(2,3) === '1' ? true : false);
                return String(permissoes).substring(2, 3) === '1' ? true : false;
            }
            if (String(perm) === 'excluir') {
                // console.log('getTemPermissao EXCLUIR: ', String(permissoes).substring(3,4) === '1' ? true : false);
                return String(permissoes).substring(3, 4) === '1' ? true : false;
            }
        }
    } else {
        return true;
    }
}




export const isLoggedIn = () => {
    return !!getToken();
}

export const getUsuario = () => {
    return jwtDecode(getToken()).usuario;
}

export const getTipoUsuario = async () => {
    return jwtDecode(getToken()).usuario.usu_tipo;
}

export const getPlanoContratado = async () => {
    return jwtDecode(getToken()).usuario.emp_plano;
}

export const getEmpresa = async () => {
    return jwtDecode(getToken()).emp_codigo;
}



// WEBPACK FOOTER //
// ./src/utils/LoginManager.js